module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('app-banner', {
    attrs: {
      "banners": _vm.banners,
      "categories": _vm.eCategories,
      "type": _vm.bannerTypes.Home
    }
  }), _vm._v(" "), _c('app-filters', {
    attrs: {
      "filters": _vm.filters
    },
    on: {
      "filter-selected": _vm.filterSelected
    }
  }), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('products-by-category', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.isLoading),
        expression: "isLoading"
      }],
      key: category.id,
      attrs: {
        "is-loading": _vm.isLoading,
        "category": category,
        "products": category.products
      }
    })
  }), _vm._v(" "), _c('app-footer')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3481be94","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 1089
// module chunks = 18